import React, { Component } from "react";
import { Link } from "react-router-dom";
import mediaImage from "./../../../assets/images/user.jpg";
import TwitterIcon from "./../../../icons/twittericon";
import InstaIcon from "./../../../icons/instaicon";
import TextField from "./../../../component/TextField";
import FpgeeditIcon from "./../../../icons/fpgediticon";
import FpgDisableIcon from "./../../../icons/fpgdisableicon";
import FpgpublishIcon from "./../../../icons/fpgpublishicon";
import FpgDeleteIcon from "./../../../icons/fpgdeleteicon";
import Slider from "react-slick";
//moment import
import moment from "moment";
//Service import
import service from "../../../services";
import ErrorPopUp from '../../errorPopUp';

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import PopUpCustomAll from "../create/popUpCustomAll";
import Loader from "../../loader";


let sub;

const mapStateToProps = state => ({
    NewFrontierEditDataEditId: state.NewFrontierEditDataEditId,
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};


class FpgNfDetailView extends Component {
  constructor() {
    super();
    this.state = {
      errorPopup:false,
      getAlldataFilm: [],
      loaderFlag: false,
      deleteFilm:false,
      publishFilm:false,
      disableFilm:false,
      screencontent:false,
      artist:[]
    };
    this.apiserve = new service();
  }

  componentDidMount() {
    {this.props.NewFrontierEditDataEditId &&
        this.getAllNewFrontierdetails();
        this.getNewFrontierdetails();
      }
      this.setState({
        loaderFlag: true,
      });
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm:false,
      publishFilm:false,
      disableFilm:false
    })
}

getNewFrontierdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "newFrontier|getAllDetail":
          if(!response.error){
          this.setState(
            {
                getAllNewFrontierdataFilm: response.data,
                access:response.data.access && response.data.access.name,
                eventiveId:response.data.eventiveId,
                mediaId: response.data.mediaId,
                images: response.data.images,
                contact:response.data.contact,
                credits: response.data.credits,
                artist:response.data.artist,
                year: response.data.year,
                category: response.data.category.name,
                country:response.data.country,
                language: response.data.language,
                runTime:response.data.runTime,
                company:response.data.company,
                website:response.data.website,
                accessibility: response.data.accessibility,
                description: response.data.description,
                shortDescription:response.data.shortDescription,
                dateTime: response.data.dateTime,
                title: response.data.title,
                status:response.data.status,
                categoryname: response.data.category.name,
                URL:response.data.URL,
                teamConnectionFirstName: response.data.teamConnection[0] && response.data.teamConnection[0].name,
                teamConnectionFirstEmail: response.data.teamConnection[0] && response.data.teamConnection[0].email,
                teamConnectionSecondName: response.data.teamConnection[1] && response.data.teamConnection[1].name,
                teamConnectionSecondEmail: response.data.teamConnection[1] && response.data.teamConnection[1].email,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              this.props.setLastUpdated({
                updatedAt: response?.data?.updatedAt,
                updatedBy: {
                  fname: response?.data?.updatedBy?.fname,
                  lname: response?.data?.updatedBy?.lname
                }
              })
            }
          );
          }else{
            this.setState({
              errorPopup:true,
              errorMsg: response.data.error ? response.data.error : response.data        
          })
          }
          break;
          case "newFrontier|remove":
            if(!response.error){
              this.props.history.push('/filmlist')
            }else{
              this.setState({
                errorPopup:true,
                errorMsg: response.data.error ? response.data.error : response.data        
            })
            }
          break;
          case "newFrontier|updateStatus":
            if(!response.error){
              this.props.history.push('/filmlist')
            }
            else{
              this.setState({
                errorPopup:true,
                errorMsg: response.data.error ? response.data.error : response.data        
            })
            }
          break;
      }
    });
  };

  getAllNewFrontierdetails = () => {
    var data = { frontierId: this.props.NewFrontierEditDataEditId };
    this.apiserve.sendevent("newFrontier|getAllDetail", data);
  };

  handelTwitter = (item) => {
    this.state.artist.forEach(element => {
      if(element._id === item._id){
        window.open(item.twitter, "_blank");
      }
    });
   
  };

  handelInstagram = (item) => {
    this.state.artist.forEach(element => {
      if(element._id === item._id){
        window.open(item.instagram, "_blank");
      }
    });
    
  };

  deleteFilm = () => {
    this.setState({
      deleteFilm:true
    })  
  }

  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("newFrontier|remove", {
        frontierId: this.props.NewFrontierEditDataEditId,
    });
  }

  publishFilm = () => {
    this.setState({
      publishFilm:true
    })  
  }

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("newFrontier|updateStatus", {
        frontierId: this.props.NewFrontierEditDataEditId,
        status: 1
    });
  }

  disableFilm = () => {
    this.setState({
      disableFilm:true
    })  
  }

  disableFilmPopupYes = () => {
    this.apiserve.sendevent("newFrontier|updateStatus", {
        frontierId: this.props.NewFrontierEditDataEditId,
        status: 2
    });
  }

  editNewFrontier = () => {
    this.props.CurrentTab(2)
    this.props.history.push({
      pathname: "/create-film",
      callFrom:2
    });
  };

  ScreenToggle = (e) => {
    var active = e.target.parentNode.closest(".inner_screen").querySelector(".screen_header").classList.toggle("active");
    var parentactive = e.target.closest(".screen_header").parentNode.parentNode.classList.toggle("active");
    var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
      if (panel && panel.style.maxHeight) {
        panel.style.maxHeight = "";
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    this.setState({
      screencontent:!this.state.screencontent
    })
  }

  errorMsgPopup = () => {
    this.setState({
        errorPopup:false
    })  
  }

  render() {
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="fpg_tabcontent d_flex">
        <>
          <div className="tab_col left_col">
            <div className="d_flex id_media d_flex_align_center">
              {   <span className="id_text">
                <label>Eventive  ID:</label> {this.state.eventiveId}
              </span>}
              <span className="id_text">
                <label>Media ID:</label> {this.state.mediaId}
              </span>
            </div>
            <Slider {...settings}>
              {this.state.images &&
                this.state.images.map((item) => (
                  <div>
                    <div className="media_image">
                      <img
                        src={
                          item.inSite ? this.apiserve.imageUrl + item.inSite : 
                          item.link ? item.link : 
                         '/images/image-placeholder.png'
                        }
                        alt="image"
                      />
                    </div>
                  </div>
                ))}
            </Slider>
            <div className="credit_section mt_15">
              <div className="credit_header">
                <h5>Credits</h5>
              </div>
              <div className="credit_content">
                <ul>
                  <li className="d_flex">
                    {this.state.credits &&
                      this.state.credits.map((item) => (
                        <>
                          <label>{item && item.creditId && item.creditId.name}</label>
                          <span className="name">
                            {item.creditType &&
                              item.creditType.map((creditTypeName) => (
                                <p>{creditTypeName.creditsInsideType}</p>
                              ))}
                          </span>
                        </>
                      ))}
                  </li>
                </ul>
              </div>
            </div>
            <div className="credit_section artist_section">
              <div className="credit_header">
                <h5>Meet The Artist</h5>
              </div>
              <div className="artist_content">
                  {this.state.artist.map((item)=>{
                    return(
                     <> 
                <div className="d_flex inner_artist mb_15">
                  
                  <div className="artist_user">
                    <img
                      src={
                        item.image
                          ? this.apiserve.imageUrl + item.image
                          : '/images/user.png'
                      }
                      alt="user"
                    />
                  </div>
                  <div className="artist_data">
                    <div className="d_flex user_name">
                      <h4>{item.name}</h4>
                      <div className="d_flex d_flex_align_center">
                      {item.twitter &&
                        <Link
                          className="d_flex d_flex_align_center"
                          onClick={()=>this.handelTwitter(item)}
                        >
                          <TwitterIcon />
                        </Link>
                      }
                      {item.instagram &&
                        <Link
                          className="d_flex d_flex_align_center"
                          onClick={()=>this.handelInstagram(item)}
                        >
                          <InstaIcon />
                        </Link>
                      }
                      </div>
                    </div>
                    <div className="user_desc">
                    
                      <div className="editor_view p_0" dangerouslySetInnerHTML={{__html: item.description}} ></div>
                      
                    </div>
                    <div className="video_wrap">
                      <iframe src={item.youtube}></iframe>
                    </div>
                  </div>
              </div>
               </>
               )
              })}
              </div>
            </div>
          </div>
          <div className="tab_col feature_col">
            <div className="fpg_edits_links d_flex d_flex_align_center">
              <Link className="d_flex d_flex_align_center d_flex_justify_center" 
               onClick={this.editNewFrontier}
              >
                <FpgeeditIcon />
                EDIT
              </Link>
              {this.state.status === 1?
                <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.disableFilm()}>
                  <FpgDisableIcon /> DISABLE
                </Link>
              :              
              <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.publishFilm()}>
                <FpgpublishIcon /> PUBLISH
              </Link>
              }
              <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.deleteFilm()}>
                <FpgDeleteIcon />
                DELETE
              </Link>
            </div>
            <div className="id_text mt_5 mb_10">
                <li className="d_flex">
                  <label>Access: </label>
                  <span>&nbsp;{this.state.access}</span>
                </li>
             
            </div>
            <p className="feature_text">{this.state.categoryname}</p>
            <div className="feature_title">
              <h3>{this.state.title}</h3>
              <div className="field_row mb_25">
                <label className="font_600"> Long Description</label>
                <div className="editor_view" dangerouslySetInnerHTML={{__html: this.state.description}} />
              </div>  
              <div className="field_row mb_25">
                <label className="font_600"> Short Description</label>
                <div className="editor_view" dangerouslySetInnerHTML={{__html: this.state.shortDescription}} />
              </div>
            </div>
            <div className="data_list">
              <ul>
                <li className="d_flex">
                  <label>Year</label>
                  <span>{this.state.year}</span>
                </li>
                <li className="d_flex">
                  <label>Category</label>
                  <span>{this.state.category}</span>
                </li>
                <li className="d_flex">
                  <label>Country</label>
                  <span>{this.state.country}</span>
                </li>
                <li className="d_flex">
                  <label>Language</label>
                  <span>{this.state.language}</span>
                </li>
                <li className="d_flex">
                  <label>Run Time</label>
                  <span>{this.state.runTime}</span>
                </li>
                <li className="d_flex">
                  <label>Company</label>
                  <span>{this.state.company}</span>
                </li>
                <li className="d_flex">
                  <label>Website</label>
                  <span>{this.state.website}</span>
                </li>
                <li className="d_flex">
                  <label>Contact</label>
                  <span>
                  {this.state.contact &&
                      this.state.contact.map((item) => <p>{item && item.emailPhone}</p>)}
                  </span>
                </li>
              </ul>
              <ul>
                <li className="d_flex">
                  <label>Accessibility</label>
                  <span>
                    {this.state.accessibility &&
                      this.state.accessibility.map((item) => (
                        <p>{item.name}</p>
                      ))}
                  </span>
                </li>
              </ul>
            </div>

            <div className="screen_dates" style={{maxWidth:"450px"}}>
              <div className="header_title">
                <h3><label>Event Start Date & Time (MT)</label> - <label>Event End Date & Time (MT)</label> - Location</h3>
              </div>
              <div className="screen_list">
                <ul>
                
                  { 
                    this.state.dateTime &&
                    this.state.dateTime.map((item) => {
                      var fpgFlimViewStart = new Date(item.date);
                      var fpgFlimViewEnd= new Date(item.endDate);
                      return(
                        item.date !== undefined &&
                      <li className="disp_flex">
                        {/* <label>{moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD') }</label>
                        <span className="time_text time_text_nf">
                        {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')} - {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                        </span> */}
                          <span className="time_text time_text_nf">
                            {moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')}  -  {moment(fpgFlimViewEnd).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                          </span>
                        <p className="d_flex">
                          
                          { 
                            item?.locationType === undefined || item.locationType === "2"  ? <span className="d_block"> Online </span> :
                            item?.locations.length > 0 ?  item?.locations.map((loc) => {
                                  return <span className="d_block"> {loc?.name} &nbsp;</span>
                              }) : ''
                          }  
                            
                          </p>
                      </li>
                     )})
                    }
            
                </ul>
              </div>
            </div>
            {this.state.URL &&
            <div className="data_list">
              <ul>
                <li className="d_flex">
                  <label>Event Link</label>
                  <span>{this.state.URL}</span>
                </li>
                </ul>
            </div>
            }
            <div className="connection_detail">
              <div className="connection_header">
                <h2>Project Team Connection Details</h2>
              </div>
              <div className="connection_data">
                <div className="connection_box">
                  <h3 className="uppercase">connection 1</h3>
                  <div className="connection_list">
                    <ul>
                      {/* {this.state.teamConnection &&
                        this.state.teamConnection.map((item,index) => (
                          <> */}
                      <li>
                        <label>Full Name</label>{" "}
                        <span>{this.state.teamConnectionFirstName}</span>
                      </li>
                      <li>
                        <label>Email</label>{" "}
                        <span>{this.state.teamConnectionFirstEmail}</span>
                      </li>
                      {/* </>
                        ))} */}
                    </ul>
                  </div>
                </div>
                <div className="connection_box">
                  <h3 className="uppercase">connection 2</h3>
                  <div className="connection_list">
                    <ul>
                      <li>
                        <label>Full Name</label>{" "}
                        <span>{this.state.teamConnectionSecondName}</span>
                      </li>
                      <li>
                        <label>Email</label>{" "}
                        <span>{this.state.teamConnectionSecondEmail}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
        {/* ))} */}
        {this.state.errorPopup ? 
                  <ErrorPopUp
                  errorMsg={this.state.errorMsg}
                  errorMsgPopup={this.errorMsgPopup}
                  />    
              : ''
        }
      {this.state.deleteFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Delete?'
            insideDetails = 'You are about to delete an item and this action is permanent'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.deleteFilmPopupYes}
          />
        :''}

      {this.state.publishFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Publish Changes'
            insideDetails = 'Saving the current changes will publish it to the production site'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.publishFilmPopupYes}
          />
        :''}

      {this.state.disableFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Disable?'
            insideDetails = 'You are about to disable an item, which will temporarily make it unavailable on the production site'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.disableFilmPopupYes}
          />
        :''}
    {/* Loader */}
         {this.state.loaderFlag ? (
                <Loader />
                  ) : (
                          ""
                )}
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FpgNfDetailView)
